import React from 'react'
import {
  AppBar, Box, Spacer,
  // Typography
} from '@fedsim/components'

// import { red, green, blue } from '@mui/material/colors';
// import { styled } from '@mui/material/styles';
import Error from 'components/error';

import Footer from './footer'
import Topbar from './topbar'
import Main from './main'
import ToggleColorMode from './color-mode';

// const Root = styled('div')(({ theme }) => ({
//   padding: theme.spacing(1),
//   [theme.breakpoints.down('md')]: {
//     backgroundColor: red[500],
//   },
//   [theme.breakpoints.up('md')]: {
//     backgroundColor: blue[500],
//   },
//   [theme.breakpoints.up('lg')]: {
//     backgroundColor: green[500],
//   },
// }));

// export function MediaQuery() {
//   return (
//     <Root>
//       <Typography>down(md): red</Typography>
//       <Typography>up(md): blue</Typography>
//       <Typography>up(lg): green</Typography>
//     </Root>
//   );
// }

function Layout({ children = null }) {
  return (
    <>
      <ToggleColorMode>
        <Box sx={{
          backgroundColor: theme => theme.palette.background.body,
          color: theme => theme.palette.text.primary,
        }}>
          <Error>
            <AppBar
              sx={{
                top: 0,
                left: 0,
                p: 0,
                position: 'absolute',
                // backgroundColor: PALETTE.HEADER,
                // color: PALETTE.HEADERTEXT,
                zIndex: theme => theme.zIndex.drawer - 1,
                // borderBottom: `3px solid ${PALETTE.DIVIDER}`
              }}
            >
              <Topbar />
            </AppBar>
            <Main>
              {children}
              <Spacer />
            </Main>
            <Footer />
          </Error>
        </Box>
      </ToggleColorMode >
    </>
  )
}

export default Layout
